import * as React from "react";

export function useTermsAgreed() {
  const [conditions, setConditions] = React.useState(false);
  const [privacyPolicy, setPrivacyPolicy] = React.useState(false);

  const allAgreed = conditions && privacyPolicy;

  return {
    setConditions,
    setPrivacyPolicy,
    conditions,
    privacyPolicy,
    allAgreed,
  };
}
